/** QuickTicketing — Coquille : identité, navigation par ancre (#/…), écrans. */
import React, { useEffect, useState } from 'react';
import { api, portalUrl } from './api/client.js';
import TicketList from './components/TicketList.jsx';
import TicketView from './components/TicketView.jsx';
import NewTicket from './components/NewTicket.jsx';
import Admin from './components/Admin.jsx';

/** #/t/TK-0001?x=y → { path: '/t/TK-0001', params } */
function readHash() {
  const raw = window.location.hash.replace(/^#/, '') || '/';
  const [path, query] = raw.split('?');
  return { path: path || '/', params: new URLSearchParams(query || '') };
}

export default function App() {
  const [route, setRoute] = useState(readHash);
  const [me, setMe] = useState(null);
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const onHash = () => { setRoute(readHash()); window.scrollTo(0, 0); };
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  useEffect(() => {
    Promise.all([api('/me'), api('/meta')])
      .then(([m, x]) => { setMe(m); setMeta(x); })
      .catch(setError);
  }, []);

  const navigate = (path) => { window.location.hash = path; };
  const portal = portalUrl();

  if (error) {
    const login = error.code === 'no_session';
    return (
      <div className="app">
        <Topbar />
        <div className="page narrow card">
          <h2>{login ? 'Connexion requise' : 'Service indisponible'}</h2>
          <p>{login ? 'QuickTicketing utilise votre compte Quick-Apps. Connectez-vous au portail, puis revenez ici.' : error.message}</p>
          {login && portal && <a className="button primary" href={portal}>Se connecter au portail</a>}
        </div>
      </div>
    );
  }
  if (!me || !meta) return <div className="app"><Topbar /><div className="page empty"><span className="spinner" /> Chargement…</div></div>;

  const { path, params } = route;
  let screen;
  let tab = 'mine';
  if (path === '/nouveau') { screen = <NewTicket meta={meta} params={params} navigate={navigate} />; tab = 'new'; }
  else if (path.startsWith('/t/')) { screen = <TicketView key={path} id={path.slice(3)} me={me} meta={meta} navigate={navigate} />; tab = null; }
  else if (path === '/admin' && me.admin) { screen = <Admin />; tab = 'admin'; }
  else if (path === '/tous' && me.admin) { screen = <TicketList key="all" scope="all" me={me} meta={meta} navigate={navigate} />; tab = 'all'; }
  else screen = <TicketList key="mine" scope="mine" me={me} meta={meta} navigate={navigate} />;

  return (
    <div className="app">
      <Topbar>
        <nav className="tabs">
          <a className={tab === 'mine' ? 'active' : ''} href="#/">Mes tickets</a>
          {me.admin && <a className={tab === 'all' ? 'active' : ''} href="#/tous">Tous les tickets</a>}
          {me.admin && <a className={tab === 'admin' ? 'active' : ''} href="#/admin">Administration</a>}
        </nav>
        <span className="spacer" />
        <span className="who">{me.username}{me.admin && <span className="tag-admin">admin</span>}</span>
        {portal && <a className="muted" href={portal}>Portail ↗</a>}
      </Topbar>
      <main>{screen}</main>
      <footer className="foot">QuickTicketing {me.version}</footer>
    </div>
  );
}

function Topbar({ children }) {
  return (
    <header className="topbar">
      <a href="#/" className="brand"><h1>Quick<span className="logo-sfx">·Ticketing</span></h1></a>
      {children}
    </header>
  );
}
